import React, { useState, useEffect } from 'react';
import { Label } from 'office-ui-fabric-react';
import { Col, Row } from 'react-flexbox-grid';
import { obtenerFechaHoraActual } from '../../helpers';

export const DetalleConfirmacionPago = ({ data }) => {
  
  const [fechaHora, setFechaHora] = useState("");  

  useEffect(() => {
    const fechaActual = obtenerFechaHoraActual();
    setFechaHora(fechaActual);
  }, [])  

  return (
    <>      
      <Row>
        <Col xs={12} sm={12}>
          <Row center="xs">
            <Col xs={12} sm={6}>
              <h3 className="current">Información del pago</h3>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row center="xs">
        <Col xs={12} sm={3}>
          <Label style={{ fontWeight: "bold" }}>Marca de tarjeta</Label>
        </Col>
        <Col xs={12} sm={3}>
          <Label>{data.tipoTarjeta}</Label>
        </Col>
      </Row>
      <Row center="xs">
        <Col xs={12} sm={3}>
          <Label style={{ fontWeight: "bold" }}>
            Número de tarjeta
          </Label>
        </Col>
        <Col xs={12} sm={3}>
          <Label>{data.tarjeta}</Label>
        </Col>
      </Row>
      <Row center="xs">
        <Col xs={12} sm={3}>
          <Label style={{ fontWeight: "bold" }}>
            Fecha y Hora de pedido
          </Label>
        </Col>
        <Col xs={12} sm={3}>
          <Label>{fechaHora}</Label>
        </Col>
      </Row>
      <Row center="xs">
        <Col xs={12} sm={3}>
          <Label style={{ fontWeight: "bold" }}>Importe</Label>
        </Col>
        <Col xs={12} sm={3}>
          <Label>{data.monto}</Label>
        </Col>
      </Row>
      <Row center="xs">
        <Col xs={12} sm={3}>
          <Label style={{ fontWeight: "bold" }}>Moneda</Label>
        </Col>
        <Col xs={12} sm={3}>
          <Label>{data.moneda}</Label>
        </Col>
      </Row>
      <Row center="xs">
        <Col xs={12} sm={3}>
          <Label style={{ fontWeight: "bold" }}>Descripción</Label>
        </Col>
        <Col xs={12} sm={3}>
          <Label>{data.descripcionPago}</Label>
        </Col>
      </Row>
      {/* {this.state.mensaje !== "" ? (
        <Row center="xs">
          <Col xs={12} sm={3}>
            <Label style={{ fontWeight: "bold" }}>Motivo</Label>
          </Col>
          <Col xs={12} sm={3}>
            <Label style={{ color: "red" }}>{this.state.mensaje}</Label>
          </Col>
        </Row>
      ) : null} */}
    </>
  )
}
